import type { SVGProps } from 'react';

export const GitHubIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M12 .5a12 12 0 0 0-3.8 23.4c.6.1.8-.2.8-.6v-2.2c-3.3.7-4-1.4-4-1.4-.5-1.3-1.2-1.7-1.2-1.7-1-.7.1-.7.1-.7 1 .1 1.6 1 1.6 1 .9 1.6 2.5 1.1 3.1.8.1-.7.4-1.1.7-1.4-2.6-.3-5.4-1.3-5.4-5.9 0-1.3.5-2.4 1.2-3.2-.1-.3-.5-1.5.1-3.1 0 0 1-.3 3.3 1.2a11.3 11.3 0 0 1 6 0c2.3-1.5 3.3-1.2 3.3-1.2.6 1.6.2 2.8.1 3.1.8.8 1.2 1.9 1.2 3.2 0 4.6-2.8 5.6-5.4 5.9.4.4.8 1 .8 2v3c0 .4.2.7.8.6A12 12 0 0 0 12 .5Z" />
  </svg>
);

export const GitLabIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="none" {...props}>
    <path d="m12 22.17 4.03-12.4H7.97L12 22.17Z" fill="#E24329" />
    <path d="m12 22.17-4.03-12.4H1.52L12 22.17Z" fill="#FC6D26" />
    <path d="M1.52 9.77.08 14.2a.98.98 0 0 0 .36 1.1L12 22.17 1.52 9.77Z" fill="#FCA326" />
    <path d="M1.52 9.77h6.45L5.56 2.5a.49.49 0 0 0-.93 0L1.52 9.77Z" fill="#E24329" />
    <path d="m12 22.17 4.03-12.4h6.45L12 22.17Z" fill="#FC6D26" />
    <path d="m22.48 9.77 1.44 4.43a.98.98 0 0 1-.36 1.1L12 22.17l10.48-12.4Z" fill="#FCA326" />
    <path d="M22.48 9.77h-6.45l2.41-7.27a.49.49 0 0 1 .93 0l3.11 7.27Z" fill="#E24329" />
  </svg>
);

export const BitbucketIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M1.7 3.2a1 1 0 0 1 .98-1.2h18.64a1 1 0 0 1 .98 1.2l-2.98 17.9a1.2 1.2 0 0 1-1.18 1H5.86a1.2 1.2 0 0 1-1.18-1L1.7 3.2Zm7.14 12.32h6.32l.86-5.04H7.98l.86 5.04Z" />
  </svg>
);

export const GitBranchIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <line x1="6" y1="3" x2="6" y2="15" />
    <circle cx="18" cy="6" r="3" />
    <circle cx="6" cy="18" r="3" />
    <path d="M18 9a9 9 0 0 1-9 9" />
  </svg>
);

export const LinearIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M2.886 4.18A11.982 11.982 0 0 1 11.99 0C18.624 0 24 5.376 24 12.009c0 3.64-1.62 6.903-4.18 9.105L2.887 4.18ZM1.817 5.626l16.556 16.556c-.524.33-1.075.62-1.65.866L.951 7.277c.247-.575.537-1.126.866-1.65ZM.322 9.163l14.515 14.515c-.71.172-1.443.282-2.195.322L0 11.358a12 12 0 0 1 .322-2.195Zm-.17 4.862 9.823 9.824a12.02 12.02 0 0 1-9.824-9.824Z" />
  </svg>
);

export const SentryIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" fill="currentColor" {...props}>
    <path d="M13.91 2.68a2.2 2.2 0 0 0-3.82 0L7.45 7.25a9.2 9.2 0 0 1 7.98 13.82h5.28a2.2 2.2 0 0 0 1.91-3.3L13.91 2.68Zm-1.65 1.1a.3.3 0 0 1 .52 0l8.71 15.09a.3.3 0 0 1-.26.45h-2.64A12.18 12.18 0 0 0 8.45 6.34l3.81-6.56Zm-6.1 6.38-1.48 2.56a5.2 5.2 0 0 1 4.49 7.8H6.24a2.28 2.28 0 0 0-2.1-3.18H1.63a.3.3 0 0 1-.26-.45l1.39-2.4a8.2 8.2 0 0 1 8.07 6.03h3a11.18 11.18 0 0 0-7.67-10.36Z" />
  </svg>
);
